import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter  } from '@angular/core';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;

  @Input() sizeLimitMb:number = 5; 
  @Input() filesNumberLimit:number = 3;
  @Input() acceptedFilesType:string[] = [];

  @Output() replaceFiles = new EventEmitter<any>();

  files: any[] = [];

  sizeLimitError:boolean = false;
  numberLimitError:boolean = false;
  fileTypeError: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  onFileDropped(event: any) {
    this.prepareFilesList(event);
  }

  fileBrowseHandler(files: any) {
    this.prepareFilesList(files);
  }

  prepareFilesList(files: Array<any>) {
    if(this.files.length + files.length > this.filesNumberLimit){
      this.numberLimitError = true;
      return
    }
    this.numberLimitError = false;
    for (const item of files) {
      if (!this.acceptedFilesType.includes("."+item.name.split(".").pop().toLowerCase())) {
        this.fileTypeError = true;
      } else if(item.size > this.sizeLimitMb *1024*1024){
        this.sizeLimitError = true;
      } else {
        this.files.push(item);
        this.replaceFiles.emit(this.files);
        this.sizeLimitError = false;
      }
    }
    this.fileDropEl.nativeElement.value = "";
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.numberLimitError = false;
    this.sizeLimitError = false;
    this.fileTypeError = false;
    this.replaceFiles.emit(this.files);

  }

  formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

}
